export function TrashIcon() {
  return (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>T r a s h</title>
      <path
        d="M3 6.28H18L17.78 17.34C17.77 17.7 17.69 18.04 17.54 18.36C17.41 18.69 17.21 18.98 16.96 19.22C16.72 19.46 16.43 19.65 16.1 19.78C15.78 19.93 15.44 20 15.08 20H6.04C5.87 20 5.69 19.98 5.5 19.94C5.15 19.89 4.83 19.75 4.54 19.54C4.42 19.47 4.29 19.37 4.14 19.22C3.89 18.98 3.69 18.69 3.54 18.36C3.41 18.04 3.33 17.7 3.32 17.34L3 6.28ZM14.88 1.24H18.62C18.97 1.24 19.26 1.37 19.5 1.62C19.75 1.86 19.88 2.15 19.88 2.5C19.88 2.85 19.75 3.15 19.5 3.4C19.26 3.64 18.97 3.76 18.62 3.76H2.38C2.03 3.76 1.73 3.64 1.48 3.4C1.24 3.15 1.12 2.85 1.12 2.5C1.12 2.15 1.24 1.86 1.48 1.62C1.73 1.37 2.03 1.24 2.38 1.24H6.12C6.12 0.89 6.24 0.6 6.48 0.36C6.73 0.12 7.03 0 7.38 0H13.62C13.97 0 14.26 0.12 14.5 0.36C14.75 0.6 14.88 0.89 14.88 1.24Z"
        fill="currentColor"
      />
    </svg>
  );
}
